// ━━━ Platform detection helpers ━━━━━━━━━━━━━━━━━━━━━━━━━━
//
// SSR-safe. Returns false on server to avoid hydration mismatches;
// the post-mount re-render corrects client-side.

export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || '');
}

/** Keyboard shortcut label for the command palette. '⌘K' on Mac, 'Ctrl+K' elsewhere. */
export function commandShortcutLabel(): string {
  return isMacPlatform() ? '⌘K' : 'Ctrl+K';
}

/**
 * Hover that only a real mouse can trigger. iOS Safari (iPhone and iPad)
 * fires mouseenter on a tap; when that handler changes what is on screen
 * (reveals row actions, focuses a row, shows a tooltip) Safari treats the tap
 * as a hover and swallows the click, and the "hovered" look sticks after the
 * finger lifts. Wire hover through pointer events and ignore touch and pen:
 *
 *   onPointerEnter={mouseOnly(() => setHover(true))}
 *
 * pointerleave is always safe to honour (it only ever clears), so callers
 * keep a plain handler there.
 */
export function mouseOnly<E extends { pointerType: string }>(fn: (e: E) => void): (e: E) => void {
  return (e) => {
    if (e.pointerType === 'mouse') fn(e);
  };
}
